"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const react_1 = require("react");
const web_slugify_url_1 = require("@snapchat/web-slugify-url");
const web_env_1 = require("@snapchat/web-env");
/**
 * This hook returns the query terms to be displayed to the user
 */
function useSearchQuery(pageType) {
    const [query, setQuery] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        // localhost and bs-local don't require /explore/ in the url hence the length should reduce by 1
        // e.g. http://bs-local.com:4000/asadedadwse?locale=ar-AR
        const expectedPartsLength = (0, web_env_1.isRunningOnDevEnv)() || (0, web_env_1.isRunningOnBSLocal)() ? 1 : 2;
        const searchQueryIndex = expectedPartsLength - 1;
        const parts = new URL(window.location.href).pathname.split("/").filter(Boolean);
        if (pageType !== web_blizzard_reporting_1.PageType.SEARCH || parts.length < expectedPartsLength) {
            return;
        }
        setQuery((0, web_slugify_url_1.fromSlugUrl)(parts[searchQueryIndex]));
    }, [pageType]);
    return query;
}
exports.default = useSearchQuery;
//# sourceMappingURL=useSearchQuery.js.map